export default "__VITE_ASSET__04f2a074__"